<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <BaseBlock title="Page d'outils">
          <h2 class="subtitle-1 font-weight-bold">Page d'outils</h2>
          <p>Cette page rassemble quelques outils intégrés dans ce gabarit</p>
        </BaseBlock>
      </v-col>
    </v-row>

    <v-row>
     
      <v-col cols="3">
        <v-card width="344" height="170" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">BIBLIOTHEQUE DE COMPOSANTS</div>
              <v-list-item-title class="headline mb-1"
                >Vuetify</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-avatar tile size="25">
              <a href="https://vuetifyjs.com" target="_blank">
                <span class="material-icons md-18">link</span>
              </a>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
     
      <v-col cols="3">
        <v-card width="344" height="170" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">BIBLIOTHEQUE D'ICONES</div>
              <v-list-item-title class="headline mb-1"
                >Material Design Icons</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-avatar tile size="25">
              <a href="https://materialdesignicons.com/" target="_blank">
                <span class="material-icons md-18">link</span>
              </a>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
     
      <v-col cols="3">
        <v-card width="344" height="170" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">MANIPULATIONS DE TABLEAUX</div>
              <v-list-item-title class="headline mb-1"
                >Lodash</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-avatar tile size="25">
              <a href="https://lodash.com/" target="_blank">
                <span class="material-icons md-18">link</span>
              </a>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </v-col>
     
      <v-col cols="3">
        <v-card width="344" height="170" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">DEMANDE DE CONFIRMATION</div>
              <v-list-item-title class="headline mb-1"
                >vuetify-confirm</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-avatar tile size="25">
              <a
                href="https://www.npmjs.com/package/vuetify-confirm"
                target="_blank"
              >
                <span class="material-icons md-18">link</span>
              </a>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions>
            <v-btn @click="confirm()">Exemple</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
     
      <v-col cols="3">
        <v-card width="344" height="170" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">INFORMATIONS ET ALERTES</div>
              <v-list-item-title class="headline mb-1"
                >vuetify-toast-snackbar</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-avatar tile size="25">
              <a
                href="https://www.npmjs.com/package/vuetify-toast-snackbar"
                target="_blank"
              >
                <span class="material-icons md-18">link</span>
              </a>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions>
            <v-btn color="blue" @click="toast('info')">Info</v-btn>
            <v-btn color="green" @click="toast('success')">Success</v-btn>
            <v-btn color="orange" @click="toast('warn')">Warn</v-btn>
            <v-btn color="red" @click="toast('error')">Error</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

export default {
  name: "Tools",
  components: { BaseBlock },
  data() {
    return {
      mdiHTML: "<v-icon>mdi-[icon]</v-icon>",
    };
  },
  methods: {
    confirm() {
     
      this.$confirm(
        "<b>Acceptez-vous quelque chose ?</b><br/>Réfléchissez bien avant d'accepter n'importe quoi !"
      ).then((res) => {
        if (res) {
          this.$toast.info("Vous avez accepté");
        } else {
          this.$toast.info("Vous n'avez pas accepté");
        }
      });
    },
    toast(type) {
      switch (type) {
        case "info":
          this.$toast.info("Ceci est une information");
          break;
        case "success":
          this.$toast.success("Ceci est une confirmation");
          break;
        case "warn":
          this.$toast.warn("Ceci est un avertissement");
          break;
        case "error":
          this.$toast.error("Ceci est une erreur");
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.material-icons.md-18 {
  font-size: 18px;
}
</style>
